import { useCallback, useState } from "react";
import LogoMini from "../../../components/icons/LogoMini";
import PlayTriangle from "../../../components/icons/PlayTriangle";
import "../general.scss";
import "./index.scss";
import Popup from "../../../components/Popup";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useData } from "../../../context/DataProvider";
import IGKiosk from "../../../assets/img/SolutionsIcons/AgilysysIGKiosk.svg";
import { Header } from "../../../components/Header";

const IGKioskFPage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const [showVideo, setShowVideo] = useState<boolean>(false);
    return(
        <div className="page splash IGKioskFPage">
            <div className="page-title"><img src={IGKiosk} alt="" /></div>
            <Header />
            <div className="text-blocks">
                <div className="std-text">
                A self-service F&B ordering kiosk that integrates with
                InfoGenesis POS to serve customers 24-7. Guests casually
select menu items, process their credit card payment and
print a receipt -- all using a simple interface. No service staff
required, reducing the time it takes to serve each guest.
                </div>
                <div className="std-text">
                The result is improved guest service, increased efficiency
                and reduced operating costs.
                </div>
            </div>
            <div className="play-video" onClick={()=>{
                _logEvent('click', "Solutions - IG Kiosk", "Play Video");
                addFlow("Play Video");
                setShowVideo(true)}}>
                <PlayTriangle />
                Play Video
            </div>
            <img className="img-1" src={"https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/IGKiosk1.png"} alt="" />
            <img className="img-2" src={"https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/IGKiosk2.png"} alt="" />
            <Popup showPopup={showVideo} setShowPopup={()=>setShowVideo(false)} disableOffClick={true}>
                <>{showVideo && <video 
                autoPlay
                controls
                src={"https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/videos/InteractiveIGKiosk.mp4"} />}</>
            </Popup>
        </div>
    )
}

export default IGKioskFPage;